import { AddressBook } from './addressBook';

export default AddressBook;